<ion-header>
  <ion-toolbar>
    <div class="icon" slot="start" (click)="goToHome()"></div>
    <ion-title>
      <div [innerHTML]="title"></div>
      <ion-text [innerHTML]="subTitle"></ion-text>
    </ion-title>
    <ion-buttons slot="end" id="main-content">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>

  </ion-toolbar>
</ion-header>

@if (menuNavigationService.productList.length > 0) {
  <app-side-menu></app-side-menu>
}